import getConfig from 'next/config'

import { Listings_Detail } from '@/types/cate-graphql-generated-types'
import { CasavoInventory } from '@/types/listing'

export type CasavoAdvantage = {
  descriptionTranslationKey: string
  iconUrl: string
  imageSize?: number
  titleTranslationKey: string
}

export const casavoAdvantagesFor = (listing: Listings_Detail): CasavoAdvantage[] => {
  switch (listing.detail.inventory) {
    case CasavoInventory.Third_Party:
      return [
        { descriptionTranslationKey: '', iconUrl: '', titleTranslationKey: 'listing-detail:form-header.agency.one' },
        { descriptionTranslationKey: '', iconUrl: '', titleTranslationKey: 'listing-detail:form-header.agency.two' },
      ]
    case CasavoInventory.iBuyer:
      return (listing.country as CateCountry) === 'italy'
        ? [
            {
              descriptionTranslationKey: '',
              iconUrl: '',
              titleTranslationKey: 'listing-detail:form-header.casavo.one',
            },
            {
              descriptionTranslationKey: '',
              iconUrl: '',
              titleTranslationKey: 'listing-detail:form-header.casavo.two',
            },
            {
              descriptionTranslationKey: '',
              iconUrl: '',
              titleTranslationKey: 'listing-detail:form-header.casavo.three',
            },
            {
              descriptionTranslationKey: '',
              iconUrl: '',
              titleTranslationKey: 'listing-detail:form-header.casavo.four',
            },
          ]
        : [
            {
              descriptionTranslationKey: '',
              iconUrl: '',
              titleTranslationKey: 'listing-detail:form-header.casavo.one',
            },
            {
              descriptionTranslationKey: '',
              iconUrl: '',
              titleTranslationKey: 'listing-detail:form-header.casavo.three',
            },
            {
              descriptionTranslationKey: '',
              iconUrl: '',
              titleTranslationKey: 'listing-detail:form-header.casavo.four',
            },
          ]
    case CasavoInventory.Agency:
      return [
        {
          descriptionTranslationKey: 'PropertyAdvantages:PropertyAdvantages_FairPrice_CardDescription',
          iconUrl: iconUrl('blocked-price'),
          titleTranslationKey: 'PropertyAdvantages:PropertyAdvantages_FairPrice_Title',
        },
        {
          descriptionTranslationKey: 'PropertyAdvantages:PropertyAdvantages_TransparencyDocumenation_CardDescription',
          iconUrl: iconUrl('docs'),
          titleTranslationKey: 'PropertyAdvantages:PropertyAdvantages_TransparencyDocumenation_Title',
        },
        {
          descriptionTranslationKey: 'PropertyAdvantages:PropertyAdvantages_SelectedPartners_CardDescription',
          iconUrl: iconUrl('trusted-collabs'),
          titleTranslationKey: 'PropertyAdvantages:PropertyAdvantages_SelectedPartners_Title',
        },
        {
          descriptionTranslationKey: 'PropertyAdvantages:PropertyAdvantages_Bureaucracy_CardDescription',
          iconUrl: iconUrl('bureaucracy'),
          titleTranslationKey: 'PropertyAdvantages:PropertyAdvantages_Bureaucracy_Title',
        },
      ]
  }
}

const iconUrl = (iconName) => {
  const {
    publicRuntimeConfig: { imageBasePath },
  } = getConfig()
  return `${imageBasePath}/images/advantages/${iconName}.svg`
}
